var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"launch-intercom",attrs:{"id":"launchIntercom","disabled":""}},[_c('i',{staticClass:"icon icon-help-2"})])
}]

export { render, staticRenderFns }